import { twClassMerge } from '@healthhub/react-ui';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { DeromBanners } from '@shared/assets';
import { Button } from '@shared/components';
import { DEROM_PATH } from '@shared/constants/paths';

const { Text, Title } = Typography;

interface DeromBannerProps {
  isForeigner: boolean;
}

const DeromBanner = ({ isForeigner }: DeromBannerProps) => {
  const { t } = useTranslation('home');
  const navigate = useNavigate();

  return (
    <div
      className={twClassMerge(
        'flex flex-col gap-6 rounded-bl-5xl rounded-tr-5xl border-4 border-white/50 bg-primary-cyan px-5 py-8',
        {
          'lg:flex-row': isForeigner,
        }
      )}
    >
      <div className="flex justify-center rounded-[2.25rem] bg-primary-yellow px-5 pt-5">
        <img
          alt="Illustration of a diverse group of four people standing together, all showing small white bandages on their arms after receiving vaccinations."
          className="h-auto max-w-full"
          src={DeromBanners}
        />
      </div>

      <div className="flex flex-col justify-between gap-4 px-4">
        <div className="flex flex-col gap-4">
          <Title className="m-0 text-2xl text-primary-blue-grey lg:text-2.5xl" lang="en" level={3}>
            {t('deromRecords')}
          </Title>
          <Text className="text-base" lang="en">
            {t('deromRecordsDescription')}
          </Text>
        </div>

        <div
          className={twClassMerge('mt-4 flex justify-center', {
            'lg:justify-start': isForeigner,
          })}
        >
          <Button
            className="w-full whitespace-normal rounded-lg border-primary-blue-grey bg-white"
            lang="en"
            onClick={() => navigate(DEROM_PATH)}
            variant="secondary"
          >
            {t('view')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeromBanner;
